<template>
  <div>
    <div class="page-main has-bottom">
      <page-title :back="true" @goback="goback" />
      <page-card v-loading="loading" style="margin-bottom: 32px">
        <template slot="header"> Well Information </template>
        <div slot="body">
          <wellComp :page-data="pageData" :well-index="1" />
        </div>
      </page-card>
    </div>
  </div>
</template>

<script>
import { wellList } from '@/api/well.js'
import wellComp from '@/views/wellManage/myWells/wellInfo.vue'
export default {
  components: {
    wellComp
  },
  data() {
    return {
      loading: false,
      pageData: {},
      wellList: []
    }
  },
  created() {
    this.getInfo()
  },
  methods: {
    getInfo() {
      this.loading = true
      const param = {
        wellID: this.$route.query.wellID
      }
      wellList(param)
        .then((res) => {
          this.pageData = res.result || {}
          // this.wellList = resData.data.wellData ? [resData.data.wellData] : [resData.data];
          // this.wellList[0].sulphur = this.wellList[0].sulphur / 100;
          // this.wellList[0].APIGravity = this.wellList[0].APIGravity / 100;
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    goback() {
      this.$router.push('/wellManagement/myWells')
    }
  }
}
</script>
<style scoped lang="scss">

</style>
